import React from "react";

export default function GithubIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 60 60"
      fill="none"
    >
      <g clipPath="url(#clip0_16213_27)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.1575 0.017334C46.7265 0.017334 60.1575 13.7871 60.1575 30.7761C60.1575 44.3631 51.5715 55.8892 39.6585 59.9602C38.1375 60.2632 37.5975 59.3026 37.5975 58.4836C37.5975 57.4696 37.6335 54.1577 37.6335 50.0417C37.6335 47.1737 36.6735 45.3019 35.5965 44.3479C42.2775 43.5859 49.2975 40.9847 49.2975 29.1707C49.2975 25.8107 48.1335 23.0688 46.2075 20.9148C46.5195 20.1378 47.5485 17.0092 45.9135 12.7732C45.9135 12.7732 43.3995 11.949 37.6725 15.927C35.2755 15.246 32.7075 14.9034 30.1575 14.8914C27.6075 14.9034 25.0425 15.246 22.6485 15.927C16.9155 11.949 14.3955 12.7732 14.3955 12.7732C12.7665 17.0092 13.7955 20.1378 14.1045 20.9148C12.1875 23.0688 11.0145 25.8107 11.0145 29.1707C11.0145 40.9547 18.0195 43.5958 24.6825 44.3728C23.8245 45.1408 23.0475 46.4956 22.7775 48.4846C21.0675 49.2706 16.7235 50.6309 14.0475 45.9299C14.0475 45.9299 12.4605 42.9745 9.44847 42.7585C9.44847 42.7585 6.52347 42.7197 9.24447 44.6277C9.24447 44.6277 11.2095 45.5727 12.5745 49.1277C12.5745 49.1277 14.3355 54.6176 22.6815 52.7576C22.6965 55.3286 22.7235 57.7516 22.7235 58.4836C22.7235 59.2966 22.1715 60.2481 20.6745 59.9631C8.75246 55.8981 0.157471 44.3661 0.157471 30.7761C0.157471 13.7871 13.5915 0.017334 30.1575 0.017334Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_16213_27">
          <rect
            width="60"
            height="60"
            fill="white"
            transform="translate(0.157471 0.017334)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
